module.exports = __webpack_public_path__ + "static/media/inventoryIcon.9b7989bc.svg";